import { render, staticRenderFns } from "./AppFooterView.vue?vue&type=template&id=6c4b6c6c&scoped=true&"
import script from "./AppFooterView.vue?vue&type=script&lang=ts&"
export * from "./AppFooterView.vue?vue&type=script&lang=ts&"
import style0 from "./AppFooterView.vue?vue&type=style&index=0&id=6c4b6c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4b6c6c",
  null
  
)

export default component.exports